export default [
  {
    path: '/mitt-dahl',
    componentName: 'MyPage',
    meta: { requiresAuth: true },
    children: [
      {
        name: 'my-page-overview',
        path: '',
        componentName: 'MyPageIndex',
      },
      {
        name: 'order-history',
        path: 'gjorda-kop',
        componentName: 'OrderHistory',
      },
      {
        name: 'order-history',
        path: 'orderhistorik',
        componentName: 'OrderHistory',
      },
      {
        path: 'gjorda-kop/:orderNumber',
        componentName: 'OrderHistoryPage',
        name: 'order-history-page',
      },
      {
        path: 'orderhistorik/:orderNumber',
        componentName: 'OrderHistoryPage',
        name: 'order-history-page',
      },
      {
        name: 'shopping-lists',
        path: 'inkopslistor',
        componentName: 'ShoppingLists',
      },
      {
        path: 'inkopslistor/:id',
        componentName: 'ShoppingList',
        name: 'shopping-list-page',
      },
      {
        name: 'my-addresses',
        path: 'mina-adresser',
        componentName: 'MyAddresses',
      },
      {
        name: 'my-store',
        path: 'min-butik',
        componentName: 'StorePage',
      },
      {
        name: 'my-profile',
        path: 'min-profil',
        componentName: 'MyProfile',
      },
      {
        path: 'administrera-anvaendare',
        componentName: 'UserAdministrator',
        meta: { requiresAdmin: true, externalRedirect: true },
        children: [
          {
            path: '',
            componentName: 'UserAdministratorListUsers',
            name: 'user-administrator-list-users',
          },
          {
            path: 'ny',
            componentName: 'UserAdministratorCreateUser',
            name: 'user-administrator-create-users',
          },
          {
            path: ':userId',
            componentName: 'UserAdministratorEditUser',
            name: 'user-administrator-edit-user',
          },
        ],
      },
    ],
  },
  {
    name: 'konfigurator',
    path: '/konfigurator',
    componentName: 'ProductConfigurationPage',
  },
];
